import { callerCreator } from "../callerCreator";
import { teamSlice } from "./teamSlice";

export default callerCreator(teamSlice.actions);
